import { gql } from '@/shared/types/gql';

export const ACCOUNT_NOTIFICATION_FIELDS = gql`
  fragment AccountNotificationFields on AccountNotification {
    id
    title
    description
    url
    externalId
    viewed
    createdAt
    receivedDate
    type {
      id
    }
  }
`;

export const GET_ACCOUNT_NOTIFICATIONS = gql`
  query AccountNotifications($page: Int, $perPage: Int) {
    account {
      notification {
        paginatedList(page: $page, perPage: $perPage) {
          items {
            ...AccountNotificationFields
          }
          pageInfo {
            hasNextPage
            page
            perPage
            totalItems
          }
        }
        unread {
          ...AccountNotificationFields
        }
      }
    }
  }
  ${ACCOUNT_NOTIFICATION_FIELDS}
`;

export const MARK_ACCOUNT_NOTIFICATIONS_READ = gql`
  mutation MarkAccountNotificationsRead($ids: [String!]) {
    account {
      notification {
        markRead(ids: $ids) {
          status
          itemIds
          errors {
            message
          }
        }
      }
    }
  }
`;

export const NEW_ACCOUNT_NOTIFICATION_SUBSCRIPTION = gql`
  subscription NewAccountNotification {
    newAccountNotification {
      ...AccountNotificationFields
    }
  }
  ${ACCOUNT_NOTIFICATION_FIELDS}
`;
